export class OwnerAddressModel {

  postalCode: string;

  constructor() {
    this.postalCode = '';
  }
}
